// Shared premium presentation tokens; scoped components consume these without changing the application theme.
export const premiumTheme = Object.freeze({
    mandatory: "#efbf73",
    recommended: "#6ab5d6",
    locked: "var(--text-icons-gray-300, #4f5b6d)",
    lockedValue: "var(--text-icons-gray-100, #d1d1d1)",
    fieldIconSize: "14px",
    requirementIndicatorSize: "9px",
    fieldBackground: "#101214",
    fieldBorder: "#565c5f",
    fieldRadius: "10px",
    fontFamily: '"Roboto", sans-serif',
    valueSize: "14px",
    valueWeight: 400,
    valueLineHeight: "20px",
    valueColor: "var(--text-icons-gray-100, #d1d1d1)",
    placeholder: "var(--text-icons-gray-200, #7c868b)",
    blockedPlaceholder: "var(--text-icons-gray-300, #4f5b6d)",
    fieldHeight: "42px",
    blockedBackground: "#121415",
    hoverBorder: "#62696c",
    invalidBorder: "#f06f74",
    focusShadow: "0 0 8px 1px rgba(239,191,115,.15)",
    panelBackground: "#17191b",
    panelSeparator: "#34393a",
    panelShadow: "0 12px 28px #0009",
    panelPadding: "12px",
    panelMuted: "#81888b",
    panelEmpty: "#a8adaf",
    searchPlaceholder: "#9ca3a5",
    optionHover: "#efbf7314",
    actionBackground: "linear-gradient(180deg, #252729, #1a1c1e)",
    assistiveSize: "12px",
    legendSize: "12px",
    fieldError: "var(--text-icons-red-500, #ff3636)"
});
